import { render } from "./BatchPaymentsReportPage.vue?vue&type=template&id=1158f734&scoped=true"
import script from "./BatchPaymentsReportPage.vue?vue&type=script&lang=js"
export * from "./BatchPaymentsReportPage.vue?vue&type=script&lang=js"

import "./BatchPaymentsReportPage.vue?vue&type=style&index=0&id=1158f734&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1158f734"]])

export default __exports__